import { Injectable } from '@angular/core';
import { ResetPasswordContent } from '@com-delta-idp/mnx-login-ui';
import { LOGIN_CONSTANTS } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordUserRequest } from '../../models/reset-password-api.interface';
import { ResetPasswordHelperService } from '../../services';

import { LoginHelperUtils } from '../../../utils/login-helper.utils';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordAdapter {
  constructor(
    protected helper: ResetPasswordHelperService,
    protected loginHelperUtils: LoginHelperUtils
  ) {}

  getResetPasswordContent(
    loginAemResponse: LoginModalContent,
    initialUserId?: string
  ): ResetPasswordContent {
    const formGroup = this.helper.createForm();
    if (initialUserId) {
      formGroup.patchValue({
        userId: { value: initialUserId, id: 'userId' }
      });
    }
    return {
      formGroup,
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getPageContent(loginAemResponse),
      hasError: false,
      errorMessage: ''
    };
  }

  setUserRequestObj(content: ResetPasswordContent): ResetPasswordUserRequest {
    const formValues = content.formGroup.getRawValue();
    const userId = formValues.userId?.value?.trim();
    let userIdType = LOGIN_CONSTANTS.SKYMILES_NUMBER;

    if (this.loginHelperUtils.isEmailValid(userId)) {
      userIdType = LOGIN_CONSTANTS.EMAIL;
    }

    if (this.loginHelperUtils.isUserName(userId)) {
      userIdType = LOGIN_CONSTANTS.USER_NAME;
    }

    return {
      abcyz: '',
      firstName: this.loginHelperUtils.setWhenNullOrUndefined(
        formValues.firstName?.value
      ),
      lastName: this.loginHelperUtils.setWhenNullOrUndefined(
        formValues.lastName?.value
      ),
      [userIdType]: userId,
      formNameSubmitted: content.pageContent.viewName
    };
  }
}
